<dhp-filter-strings-select-dialog
  class="hidden md:flex"
  [filterName]="filterName"
  [originalStrings]="typeItems()"
  [selected]="selectedTypeItems()"
  (stringsOutput)="selectedArticleTypes.emit($event)"
/>
<dhp-filter-strings-select-accordion
  class="md:hidden"
  [filterName]="filterName"
  [originalStrings]="typeItems()"
  [selected]="selectedTypeItems()"
  (stringsOutput)="selectedArticleTypes.emit($event)"
/>
